import React from "react";
import {
	AutocompleteInput,
	NumberInput,
	ReferenceInput,
	required,
	SimpleForm,
} from "react-admin";
import InfoField from "./fields/InfoField";
import DayInput from "./inputs/DayInput";

const Form = (props) => (
	<SimpleForm {...props} redirect="list">
		<DayInput source="day" />
		<ReferenceInput
			source="bookmaker_id"
			reference="bookmakers"
			validate={required()}
			perPage={100}
			sort={{ field: "name", order: "ASC" }}
			filter={{ status: "active" }}
		>
			<AutocompleteInput optionText="name" />
		</ReferenceInput>
		<ReferenceInput
			source="user_id"
			reference="users"
			validate={required()}
			emptyText="ra.users.all_users"
		>
			<AutocompleteInput optionText="name" />
		</ReferenceInput>
		<InfoField />
		<NumberInput source="amount" validate={required()} />
	</SimpleForm>
);

export default Form;
